// extracted by mini-css-extract-plugin
module.exports = {"root":"PriorityFirstSwitch_root__3VIpO"};